(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["s23-upload-help"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target.closest('.s23-copy-prompt');
    if (!button) return;
    const panel = button.closest('.s23-upload-details');
    const prompt = panel.querySelector('.s23-enhance-prompt');
    const status = panel.querySelector('.s23-copy-status');
    try {
      await navigator.clipboard.writeText(prompt.value);
      status.textContent = status.dataset.copied;
    } catch {
      prompt.focus();
      prompt.select();
      prompt.setSelectionRange(0, prompt.value.length);
      status.textContent = status.dataset.fallback;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
